import { RouteConfig } from 'src/routing/types'

const ROUTE: RouteConfig = {
  name: 'hall-of-fame-view',
  path: ({ slug }: { slug?: number }) => `/hall-of-fame/${slug}`,
}

export default ROUTE
